import { useUserState } from './useUserState';

/**
 * Hook for balance data
 * Now wraps useUserState to avoid duplicate API calls
 */
export function useBalance() {
  const { balance, accountValue, isLoading, isConnected } = useUserState();

  return {
    balance,
    accountValue,
    isLoading,
    isConnected,
  };
}
